import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import ModuleAccessManagement from '../../components/ModuleAccessManagement';
import { transcriptionAPI } from '../../api/transcriptionApi';

const TranscriptionAccessPage = () => (
  <ModuleAccessManagement
    title="Ses → Metin Erişimi"
    description="Bu modülü görebilecek ve kullanabilecek kullanıcıları seçin."
    api={transcriptionAPI}
    accent="rose"
    icon={ShieldCheckIcon}
  />
);

export default TranscriptionAccessPage;
